import { apiClient } from './client';
import type { AssetFieldDefinition, AssetFieldDefinitionWrite } from '@/types/oscar';

export function listFieldDefinitions(category?: string, signal?: AbortSignal): Promise<AssetFieldDefinition[]> {
  const q = category ? `?category=${encodeURIComponent(category)}` : '';
  return apiClient.get<AssetFieldDefinition[]>(`/api/asset-field-definitions${q}`, signal);
}
export function createFieldDefinition(body: AssetFieldDefinitionWrite): Promise<AssetFieldDefinition> {
  return apiClient.post<AssetFieldDefinition>('/api/asset-field-definitions', body);
}
export function updateFieldDefinition(id: number, body: AssetFieldDefinitionWrite): Promise<AssetFieldDefinition> {
  return apiClient.patch<AssetFieldDefinition>(`/api/asset-field-definitions/${id}`, body);
}
export function deleteFieldDefinition(id: number): Promise<unknown> {
  return apiClient.post(`/api/asset-field-definitions/${id}/delete`);
}
